import { atom, selector } from 'recoil'

export const searchState = atom({
  key: 'workflowStatistics__SearchState',
  default: {
    searchText: '',
    totalItems: undefined
  }
})

export const resultsState = atom({
  key: 'workflowStatistics__ResultsState',
  default: {
    id: 0,
    recipientContact: undefined,
    subscribedOn: undefined
  }
})

export const noResultsState = selector({
  key: 'workflowStatistics__NoResultsState',
  get: ({ get }) => {
    const { totalItems } = get(searchState)

    return totalItems === 0
  }
})
